import ENV from 'tio-employee/config/environment';
import createStore from 'tio-data/store-factory';
import { impersonationProvider, readOnlyProvider, demoProvider } from 'tio-data/app-context';
import { manifest } from 'tio-employee/schemas';

// ADR-001: auth-context installs live request providers at boot; keep this factory owner-independent.
const AppStore = createStore(
  {
    apiKey: ENV.apiKey,
    contentType: 'application/vnd.api+json',
    accept: 'application/vnd.api+json',
    jsonApiKeyFormat: 'camelized',
    sessionRenewal: {
      passToken: false,
    },
    impersonation: impersonationProvider,
    readOnly: { ...readOnlyProvider, apiHost: ENV.apiHost },
    response: {
      invalidateStatuses: [401],
      toastStatuses: [400, 403, 422],
    },
    demo: demoProvider,
  },
  manifest
);

export default AppStore;
export type TioEmployeeStore = InstanceType<typeof AppStore>;
